import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { enableMockWebSocket } from "./lib/websocket-mock";

// Enable mock WebSocket in development when VITE_USE_MOCK_WS=true
enableMockWebSocket();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
